import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactImageMagnify from "react-image-magnify";
import { CartContext } from "../../Utils/CartContext";
import { WishlistContext } from "../../Utils/WishlistContext";
import axios from "axios";
import { IoAddSharp, IoRemoveSharp, IoStar } from "react-icons/io5";
import {
  AiOutlineHome,
  AiOutlineLoading3Quarters,
  AiOutlineMinus,
  AiOutlinePlus,
} from "react-icons/ai";
import { TbHeartCheck, TbHeartPlus } from "react-icons/tb";
import SweetAlert2 from "react-sweetalert2";
import DOMPurify from "dompurify";
import {
  Badge,
  Button,
  ButtonGroup,
  ButtonToolbar,
  Card,
  Col,
  Row,
} from "react-bootstrap";
import RelatedProducts from "../../components/Products/RelatedProducts";
import RecentProducts from "../../components/Products/RecentProducts";
import SecureLS from "secure-ls";
import More from "./More";

function ProductDetails() {
  const ls = new SecureLS({ encodingType: "aes" });
  const { productName } = useParams();
  const product_name = productName.replace(/-/g, " ");
  const base_url = "https://karstar.in/";

  const [item, setItem] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { addToCart } = useContext(CartContext);
  const { addToWishlist, removeFromWishlist } = useContext(WishlistContext);
  const [testimonials, setTestimonials] = useState([]);

  const [isAddedToCart, setIsAddedToCart] = useState(false);
  const [showLoadingIconCart, setShowLoadingIconCart] = useState(false);
  const [isAddedToWishlist, setIsAddedWishlist] = useState(false);
  const [showLoadingIconWishlist, setShowLoadingIconWishlist] = useState(false);
  const [swalProps, setSwalProps] = useState({});
  const [selectedSize, setSelectedSize] = useState(null);

  useEffect(() => {
    const sessionId = sessionStorage.getItem("sessionId");
    const username = ls.get("userEmail");
    fetchProduct(sessionId, username, product_name);
  }, [product_name]);

  const fetchProduct = async (sessionId, username, product_name) => {
    try {
      const response = await axios.get(
        `https://karstar.in/api/client_api/products/getproductdetails/index.php`,
        {
          params: {
            name: product_name,
            email: username || "na",
            ipadd: sessionId || "na",
          },
        }
      );
      const fetchedItem = response.data.data[0];
      if (!fetchedItem) {
        throw new Error(`Product "${product_name}" not found`);
      }
      setItem(fetchedItem);
      updateRecentlyViewed(fetchedItem);
      setMainImage(base_url + (fetchedItem.images?.[0] || ""));
      setSelectedSize(
        fetchedItem.price[0].weight + fetchedItem.price[0].abbrevation
      ); // Default size
      setTestimonials(
        fetchedItem.review_and_ratings ? fetchedItem.review_and_ratings : []
      );
      setIsLoading(false);
    } catch (err) {
      console.error("Failed to load product details:", err);
      setError(err.message);
      setIsLoading(false);
    }
  };

  const updateRecentlyViewed = (product) => {
    let recentlyViewed = [];
    try {
      const parsed = JSON.parse(localStorage.getItem("recentlyViewed"));
      recentlyViewed = Array.isArray(parsed)
        ? parsed.filter((item) => item && item.id != null)
        : [];
    } catch (err) {
      console.error("Corrupted recentlyViewed in localStorage, resetting:", err);
      localStorage.removeItem("recentlyViewed");
    }

    if (!product || product.id == null) {
      return;
    }

    // Check if the product is already in the list
    const exists = recentlyViewed.find((item) => item.id === product.id);

    if (!exists) {
      // Add the new product to the beginning of the array
      recentlyViewed.unshift(product);

      // Keep only the last 5 items (for example)
      if (recentlyViewed.length > 7) {
        recentlyViewed.pop();
      }

      // Save back to local storage
      localStorage.setItem("recentlyViewed", JSON.stringify(recentlyViewed));
    }
  };

  const handleThumbnailClick = (image) => {
    setMainImage(
      base_url +
        image.replace("uploads", "media").replace("w3prouploads", "karstar")
    );
  };

  const handleQuantityChange = (change) =>
    setQuantity(Math.max(1, quantity + change));

  const handleAddToCart = async () => {
    const sessionId = sessionStorage.getItem("sessionId");
    const username = ls.get("userEmail");
    const selectedPriceDetails = item.price.find(
      (p) => p.weight + p.abbrevation === selectedSize
    );
    // console.log('id:',sessionId, 'email:',username);
    const success = username
      ? await addToCart("na", username, {
          selectedProdCode: selectedPriceDetails,
          quantity,
        })
      : await addToCart(sessionId || "na", "na", {
          selectedProdCode: selectedPriceDetails,
          quantity,
        });

    if (success) {
      setSwalProps({
        show: true,
        title: item?.name,
        text: "Added to Cart!",
        icon: "success",
        confirmButtonText: "Okay",
        confirmButtonColor: "#cc0001",
        allowOutsideClick: false,
      });
    } else {
      console.error("Failed to add to cart");
      setSwalProps({
        show: true,
        title: item?.name,
        text: "Failed to add to cart!",
        icon: "error",
        confirmButtonText: "Try again.",
        confirmButtonColor: "#cc0001",
        allowOutsideClick: false,
      });
    }
  };

  const handleAddToWishlist = async () => {
    setShowLoadingIconWishlist(true);
    const sessionId = sessionStorage.getItem("sessionId");
    const username = ls.get("userEmail");
    const selectedPriceDetails = item.price.find(
      (p) => p.weight + p.abbrevation === selectedSize
    );
    const success = username
      ? await addToWishlist("na", username, {
          ...item,
          selectedProdCode: selectedPriceDetails.prodcode,
        })
      : await addToWishlist(sessionId || "na", "na", {
          ...item,
          selectedProdCode: selectedPriceDetails.prodcode,
        });
    if (success) {
      // console.log(`Added ${item.name} to wishlist`);
      setShowLoadingIconWishlist(false);
    } else {
      // console.error('Failed to add to wishlist');
      setShowLoadingIconWishlist(false);
    }
  };

  const handleRemoveFromWishlist = async () => {
    const sessionId = sessionStorage.getItem("sessionId");
    const username = ls.get("userEmail");
    const selectedPriceDetails = item.price.find(
      (p) => p.weight + p.abbrevation === selectedSize
    );
    const success = username
      ? await removeFromWishlist("na", username, {
          ...item,
          selectedProdCode: selectedPriceDetails.prodcode,
        })
      : await removeFromWishlist(sessionId || "na", "na", {
          ...item,
          selectedProdCode: selectedPriceDetails.prodcode,
        });
    if (success) {
      // console.log(`Removed ${item.name} from wishlist`);
    } else {
      // console.error('Failed to remove from wishlist');
    }
  };

  const generateSlug = (name) => {
    return name.toLowerCase().replace(/ /g, "-");
  };

  if (isLoading) {
    return (
      <div className="container py-5 text-center text-muted">Loading...</div>
    );
  }

  if (error) {
    return (
      <div className="container py-5 text-center">
        <h5 className="text-black mb-3">We couldn't load this product</h5>
        <p className="text-muted">{error}</p>
        <Link to="/" className="btn btn-outline-dark rounded-2 mt-2">
          Back to Home
        </Link>
      </div>
    );
  }

  const sanitizeHTML = (html) => {
    return DOMPurify.sanitize(html);
  };

  const handleSizeChange = (size) => setSelectedSize(size);

  const handlevariantChange = (item) => {
    setItem(item);
    setMainImage(base_url + item.images[0]);
    setSelectedSize(item.price[0].weight + item.price[0].abbrevation); // Default size

    const newUrl = `/product/${generateSlug(item.name)}`;
    window.history.replaceState(null, "", newUrl);
  };
  const Discount =
    ((item.price.find((p) => p.weight + p.abbrevation === selectedSize)
      ?.basePrice -
      item.price.find((p) => p.weight + p.abbrevation === selectedSize)
        ?.discountedPrice) /
      item.price.find((p) => p.weight + p.abbrevation === selectedSize)
        ?.basePrice) *
    100;
  const DiscountNearestPercentage = Math.round(Discount);

  return (
    <div className="pb-5 sectionView  mt-3">
      <div className="container">
        <div className="breadcrumb-container pb-2">
          <div className="breadcrumb">
            <a to="/" className="breadcrumb-item text-black me-2">
              <AiOutlineHome size={20} />
            </a>
            <a to="/collections" className="breadcrumb-item text-black me-2">
              Collections
            </a>
            <a
              to={`/collections/${item.collection.filter(
                (collection) => collection !== "All Products"
              )}`}
              className="breadcrumb-item text-black me-2"
            >
              {item.collection.filter(
                (collection) => collection !== "All Products"
              )}
            </a>
            <div className="breadcrumb-item text-black me-2">
              {product_name}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div style={{ position: "sticky", top: "18vh" }}>
              <div className="border rounded-0 mb-3 d-flex justify-content-center">
                <div className="d-none d-md-block d-lg-block">
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: "Main Product",
                        isFluidWidth: true,
                        src: mainImage,
                      },
                      largeImage: {
                        src: mainImage,
                        width: 900,
                        height: 1080,
                      },
                      lensStyle: {
                        backgroundColor: "rgba(0,0,0,.6)",
                        zIndex: "9999",
                      },
                      shouldUsePositiveSpaceLens: true,
                    }}
                  />
                </div>
                <div className="d-block d-md-none d-lg-none">
                  <img
                    src={mainImage}
                    alt="Main Product"
                    style={{ width: "100%", height: "auto" }}
                  />
                </div>
              </div>
              <div className="mb-3 productsimage-scroll-container">
                {item.images.map((image, index) => (
                  <a
                    key={index}
                    data-fslightbox="mygalley"
                    className="ms-1 rounded-2 image-item"
                    data-type="image"
                    onClick={() => handleThumbnailClick(image)}
                  >
                    <img
                      width={60}
                      height={60}
                      className="rounded-2"
                      src={base_url + image}
                      alt={`Thumbnail ${index}`}
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-6 mt-3">
            <div>
              <h3 className="text-dark">{item.name}</h3>
              <div className="d-flex flex-row my-3">
                <div className="text-warning mb-1 me-2">
                  <IoStar />
                  <span className="ms-1">
                    {
                      item.price.find(
                        (p) => p.weight + p.abbrevation === selectedSize
                      )?.average_rating
                    }
                  </span>
                </div>
                <span className="text-muted">
                  <i className="fas fa-shopping-basket fa-sm mx-1" />
                  {
                    item.price.find(
                      (p) => p.weight + p.abbrevation === selectedSize
                    )?.delivered_sales_count
                  }{" "}
                  orders
                </span>
                <span
                  className={`text-${
                    item.price.find(
                      (p) => p.weight + p.abbrevation === selectedSize
                    )?.inStock
                      ? "success"
                      : "danger"
                  } mx-2`}
                >
                  {item.price.find(
                    (p) => p.weight + p.abbrevation === selectedSize
                  )?.inStock
                    ? "In stock"
                    : "Out of stock"}
                </span>
                {showLoadingIconWishlist ? (
                  <AiOutlineLoading3Quarters
                    size={20}
                    color="#FF0000"
                    className="ms-2 rotate"
                  />
                ) : isAddedToWishlist || item.in_wishlist ? (
                  <TbHeartCheck
                    size={20}
                    onClick={
                      isAddedToWishlist || item.in_wishlist
                        ? handleRemoveFromWishlist
                        : handleAddToWishlist
                    }
                    color="#FF0000"
                  />
                ) : (
                  <TbHeartPlus
                    size={20}
                    onClick={
                      isAddedToWishlist || item.in_wishlist
                        ? handleRemoveFromWishlist
                        : handleAddToWishlist
                    }
                    color="#FF0000"
                  />
                )}
              </div>
              <div className="mb-3">
                <div>
                  <div>
                    <span className="text-black text-decoration-line-through">
                      Rs{" "}
                      {item.price.find(
                        (p) => p.weight + p.abbrevation === selectedSize
                      )?.basePrice || item.price[0].basePrice}
                    </span>
                    <h4 className="text-black">
                      Rs{" "}
                      {item.price.find(
                        (p) => p.weight + p.abbrevation === selectedSize
                      )?.discountedPrice || item.price[0].discountedPrice}
                      <span
                        className="badge abstext-danger text-danger ms-2 rounded-5"
                        style={{ background: "#ff333352" }}
                      >
                        {DiscountNearestPercentage}%
                      </span>
                    </h4>{" "}
                  </div>
                </div>
              </div>
              <h5 className="text-black mb-3">Choose {item?.price?.[0]?.abbrevation}</h5>
              <ButtonToolbar className="mb-4">
                {item.price.map((p, index) => (
                  <Button
                    key={index}
                    variant={
                      selectedSize === p.weight + p.abbrevation
                        ? "dark"
                        : "outline-dark"
                    }
                    onClick={() => handleSizeChange(p.weight + p.abbrevation)}
                    className="mx-1 rounded-5"
                  >
                    {p.weight + " " + p.abbrevation}
                  </Button>
                ))}
              </ButtonToolbar>

              {item?.barcode && (
                <div>
                  <More productBarcode={item?.barcode} sku={item?.sku} />
                </div>
              )}
              {/* <Link to={item.price.find(p => p.weight + p.abbrevation === selectedSize)?.inStock ? `/checkout` : ''} state={{ item: item, isBuyNow: 'yes', isCart: 'no' }}>
                                <button disabled={item.price.find(p => p.weight + p.abbrevation === selectedSize)?.inStock ? false : true} className="btn btn-danger shadow-0 me-2 w-100" style={{ background: '#CC0000', color: 'white' }}>
                                    Buy now
                                </button>
                            </Link>
                            <button disabled={item.price.find(p => p.weight + p.abbrevation === selectedSize)?.inStock ? false : true} className="btn shadow-0 w-50 me-1" style={{ background: '#CC0000', color: 'white' }} onClick={handleAddToCart}>
                                <i className="me-1 fa fa-shopping-basket" /> Add to cart
                            </button>
                            <button disabled={item.price.find(p => p.weight + p.abbrevation === selectedSize)?.inStock ? false : true} className="btn shadow-0 w-25" style={{ background: '#CC0000', color: 'white' }} onClick={isAddedToWishlist || item.in_wishlist ? handleRemoveFromWishlist : handleAddToWishlist}>
                                {showLoadingIconWishlist ? (
                                    <AiOutlineLoading3Quarters size={20} color='#EC1F29' className='rotate' />
                                ) : isAddedToWishlist || item.in_wishlist ? (
                                    <TbHeartCheck size={20} color='#FFF' />
                                ) : (
                                    <TbHeartPlus size={20} color='#FFF' />
                                )}
                            </button> */}
              <div className="quantity-selector mb-3 d-flex">
                <ButtonGroup className="me-3">
                  <Button
                    className="bg-black text-white border-0 rounded-start-2"
                    onClick={() => handleQuantityChange(-1)}
                  >
                    <IoRemoveSharp />
                  </Button>
                  <span className="align-self-center bg-black text-white px-4 py-2 fw-bold">
                    {quantity}
                  </span>
                  <Button
                    className="bg-black text-white border-0 rounded-end-2"
                    onClick={() => handleQuantityChange(1)}
                  >
                    <IoAddSharp />
                  </Button>
                </ButtonGroup>
                <Button
                  variant="outline-dark"
                  className="rounded-2 w-75"
                  disabled={!item.price?.[0]?.inStock}
                  onClick={handleAddToCart}
                >
                  Add to Cart
                </Button>
              </div>
              <Link
                to={item.price?.[0]?.inStock ? `/checkout` : ""}
                state={{
                  item: item,
                  isBuyNow: "yes",
                  isCart: "no",
                  selectedSize: selectedSize,
                }}
              >
                <Button
                  disabled={!item.price?.[0]?.inStock}
                  variant="primary"
                  className="rounded-2 w-100"
                  style={{ background: "#cc0001", border: "#cc0001" }}
                >
                  Buy Now
                </Button>
              </Link>
              <hr style={{ zIndex: -1, position: "relative" }} />
              <div className="row">
                <h6 className="title py-2 fs-5">Product Details</h6>
                <p
                  className="text-black"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTML(item.description),
                  }}
                ></p>
                {item.warranty.length > 0 && (
                  <>
                    <h6 className="title py-2 fs-5">Warranty Details</h6>
                    {item.warranty.map((item, index) => (
                      <div key={index} className="mb-2">
                        <span>
                          <strong>{item.option}:</strong>{" "}
                          {item.values.join(", ")}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {swalProps.show && (
        <SweetAlert2
          didClose={() => {
            setSwalProps({
              show: false,
            });
          }}
          {...swalProps}
        />
      )}
      <RelatedProducts
        productCollection={item.collection.filter(
          (collection) => collection !== "All Products"
        )}
      />
      <RecentProducts />
    </div>
  );
}

export default ProductDetails;
